module.exports = { id: "user-circle", url: "/build/app/img/symbols.svg#user-circle", viewBox: "", toString: function() { return this.url; } };